import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=79e199b2&scoped=true&"
import script from "./TaskDetail.vue?vue&type=script&lang=ts&"
export * from "./TaskDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=79e199b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e199b2",
  null
  
)

export default component.exports